import { StandardEvents } from '@shopify/events';

const HEADER_SELECTOR = '.custom-header-wrapper';
const CART_COUNT_SELECTOR = '[data-cart-count]';
const WISHLIST_COUNT_SELECTOR = '[data-wishlist-count]';

function setHeaderHeight() {
  const header = document.querySelector(HEADER_SELECTOR);
  if (!(header instanceof HTMLElement)) return;

  const height = Math.ceil(header.getBoundingClientRect().height);
  if (height <= 0) return;

  document.body.style.setProperty('--ritual-custom-header-height', `${height}px`);
  document.body.style.setProperty('--header-height', `${height}px`);
  document.body.style.setProperty('--header-group-height', `${height}px`);
  document.body.style.setProperty('--sticky-header-offset', `${height}px`);
}

function setCount(selector, count) {
  const value = Number(count) || 0;
  const text = value > 0 ? String(value) : '';

  document.querySelectorAll(selector).forEach((node) => {
    node.textContent = text;
    node.dataset.count = String(value);
    node.classList.toggle('visually-hidden', value === 0 && selector === CART_COUNT_SELECTOR);
  });
}

async function refreshCartCount() {
  try {
    const response = await fetch(`${Theme.routes.cart_url}.js`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!response.ok) return;

    const cart = await response.json();
    setCount(CART_COUNT_SELECTOR, cart.item_count);
  } catch (_error) {
    // Keep the server-rendered count if the cart endpoint is unavailable.
  }
}

function syncWishlistCountFromInstance() {
  if (!window.themeWishlist?.items) return;
  setCount(WISHLIST_COUNT_SELECTOR, window.themeWishlist.items.length);
}

function bindCartEvents() {
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    event.promise
      ?.then(({ cart, detail }) => {
        const count = cart?.totalQuantity ?? detail?.itemCount;
        if (typeof count === 'number') {
          setCount(CART_COUNT_SELECTOR, count);
        } else {
          refreshCartCount();
        }
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') refreshCartCount();
      });
  });

  window.addEventListener('pageshow', refreshCartCount);
}

function bindWishlistEvents() {
  window.addEventListener('wishlist:updated', (event) => {
    setCount(WISHLIST_COUNT_SELECTOR, event.detail?.items?.length);
  });

  window.addEventListener('storage', syncWishlistCountFromInstance);
  document.addEventListener('shopify:section:load', () => {
    setHeaderHeight();
    syncWishlistCountFromInstance();
    refreshCartCount();
  });
}

setHeaderHeight();
bindCartEvents();
bindWishlistEvents();
syncWishlistCountFromInstance();
refreshCartCount();

window.addEventListener('resize', setHeaderHeight);
window.addEventListener('load', setHeaderHeight);
